import Vue from "vue";
import { Component } from "vue-property-decorator";
import { NavBar } from "@/components";
import { IPermission } from "@/models";

@Component({
    name: "home",
    components: {
        navbar: NavBar,
    },
})
export default class Home extends Vue {
    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public toggleFullScreen(): void {
        this.$store.dispatch("app/toggleFullScreen");
    }
}
